import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { HistorialAutorizacionesPage } from "@/features/historial-autorizaciones/components/HistorialAutorizacionesPage";
import {
  HISTORIAL_PAGE_SIZE,
  historialAutorizacionesQueryOptions,
} from "@/features/historial-autorizaciones/hooks/use-historial-autorizaciones";

/**
 * Ruta `/autorizacion/historial` · listado del historial de firmas del
 * usuario actual. Autorizador y MesaDeControl.
 *
 * El loader precarga la MISMA queryKey que arma la página al montar
 * (sin filtros · página 1) para que el primer render no re-fetchee.
 */
export const Route = createFileRoute("/_authed-tw/autorizacion/historial")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(
      historialAutorizacionesQueryOptions({ page: 1, pageSize: HISTORIAL_PAGE_SIZE }),
    ),
  component: () => (
    <PermissionGate permisos={[PERMISOS.autorizacionAutorizar]}>
      <HistorialAutorizacionesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
